module.exports = __webpack_public_path__ + "static/media/206-private-events.2e492a81.jpg";